// autopilot-ui-messages translations (Spanish catalog).
window.PlummeI18n.register('es', {
  'apu.confidence': '{pct} de confianza',
  'apu.voucherLinked': 'Justificante vinculado: {name}',
  'apu.taskApproved': 'Tarea aprobada 🟣',
  'apu.approvalNeedsCompany': 'La aprobación requiere que hayas iniciado sesión con una empresa activa.',
  'apu.theTaskApproved': 'La tarea se ha aprobado 🟣',
  'apu.approveFailed': 'No se pudo aprobar la tarea.',
  'apu.agentChecksApproved': 'Se han aprobado {count} controles de agentes.',
  'apu.approveChecksFailed': 'No se pudieron aprobar los controles de agentes.',
  'apu.updateProposalFailed': 'No se pudo actualizar la propuesta.',
  'apu.postponeFailed': 'No se pudo posponer la línea.',
  'apu.linkVoucherFailed': 'No se pudo vincular el justificante.',
  'apu.linkedManually': 'Justificante vinculado manualmente',
});
